define('Components/AboutComeInWidget/js/AboutComeInWidget',['hooks', 'Components/AboutComeInWidget/js/view/AboutComeInWidgetView', 'Components/AboutComeInWidget/js/model/AboutComeInWidgetModel'],
  function (hooks, AboutComeInWidgetView, AboutComeInWidgetModel) {

    return function () {
      hooks.registerWidgetInstance(
        'AboutComeInWidget',
        AboutComeInWidgetView,
        AboutComeInWidgetModel
      );
    }
  });
